import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConsultationMapItemLvt } from './consultation-map-lvt.model';
import { AuthenticationService } from '../security/authentication.service';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { DOC_LIST_BY_CMR_ID_API, PDF_DOC_API } from '../api.constants';
import { DocumentListItem } from './document.model';

/**
 * Audit service
 */
@Injectable()
export class AuditService {

    /**
     * The "constructor"
     * @param {HttpClient} http
     * @param {AuthenticationService} authenticationService
     */
    constructor(private http: HttpClient,
                private authenticationService: AuthenticationService) {
    }

    /**
     * Get doc list by cmr id
     * @param cmrId
     * @returns {Observable<DocumentListItem[]>}
     */
    public getDocListByCmrId(cmrId): Observable<DocumentListItem[]> {
        return this.http.get<DocumentListItem[]>(DOC_LIST_BY_CMR_ID_API(cmrId)).pipe(
            map(res => {
                return res;
            }),
            catchError(this.authenticationService.handleError)
        );
    }

    public getPdfDoc(pdfName: string): Observable<Blob> {
        console.log(PDF_DOC_API(pdfName));
        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf');
        return this.http.get( PDF_DOC_API(pdfName), {headers, responseType: 'blob'});
    }
}



// WEBPACK FOOTER //
// ./src/app/services/audit/audit.service.ts